module.exports = __webpack_public_path__ + "img/contact-bg.b19c6502.png";